import React, { useState, useEffect } from 'react';
import api from '../api';
import { FaFileImport, FaTimes } from 'react-icons/fa';
import ProductImport from './ProductImport';

const ProductForm = ({ produtoEditado, fecharModal }) => {
    const [produto, setProduto] = useState({
        nome: '',
        codigo_barras: '',
        codigo_barras_alternativo: '',
        unidade_peso: 'kg',
        estoque_minimo: '',
        lead_time_dias: '0'
    });

    const [mostrarModalImportacao, setMostrarModalImportacao] = useState(false);

    useEffect(() => {
        if (produtoEditado) {
            console.log("🛠️ Produto recebido para edição:", produtoEditado);
            setProduto({
                ...produtoEditado,
                lead_time_dias: produtoEditado.lead_time_dias || '0'
            });
        }
    }, [produtoEditado]);
        
    const handleChange = (e) => {
        setProduto({ ...produto, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        try {
            const dados = {
                nome: produto.nome.trim(),
                codigo_barras: produto.codigo_barras.trim(),
                codigo_barras_alternativo: produto.codigo_barras_alternativo?.trim() || '',
                unidade_peso: produto.unidade_peso,
                estoque_minimo: parseInt(produto.estoque_minimo) || 0,
                lead_time_dias: parseInt(produto.lead_time_dias) || 0
            };
            
            console.log('📦 Dados sendo enviados:', dados);
            
            if (produtoEditado) {
                await api.put(`/produtos/${produto.id}`, dados);
                alert('Produto atualizado com sucesso!');
            } else {
                await api.post('/produtos', dados);
                alert('Produto cadastrado com sucesso!');
            }
            
            fecharModal();

        } catch (error) {
            console.error('Erro ao salvar produto:', error);
            alert(`Erro ao salvar produto: ${error.response?.data?.erro || error.message}`);
        }
    };

    return (
        <div 
            className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50"
            style={{ zIndex: 9998 }} 
        >
            <div 
                className="bg-white p-6 rounded-lg shadow-lg w-full max-w-lg relative"
                style={{ 
                    maxHeight: '90vh',
                    overflowY: 'auto',
                    zIndex: 9999 
                }}
            >
                <button 
                    className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
                    onClick={fecharModal}
                >
                    <FaTimes size={20} />
                </button>

                <h2 className="text-2xl font-semibold text-center text-gray-700 mb-6">
                    {produtoEditado ? 'Editar Produto' : 'Cadastro de Produto'}
                </h2>

                {!produtoEditado && (
                    <button
                        className="bg-blue-500 text-white px-4 py-2 mb-4 rounded-lg flex items-center justify-center w-full hover:bg-blue-600 transition"
                        onClick={() => setMostrarModalImportacao(true)}
                    >
                        <FaFileImport className="mr-2" /> Importar Produtos
                    </button>
                )}

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-gray-700 font-medium">Nome do Produto *</label>
                        <input
                            type="text"
                            name="nome"
                            value={produto.nome}
                            onChange={handleChange}
                            autoComplete="off"
                            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-400"
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-gray-700 font-medium">Código de Barras *</label>
                        <input
                            type="text"
                            name="codigo_barras"
                            value={produto.codigo_barras}
                            onChange={handleChange}
                            autoComplete="off"
                            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-400"
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-gray-700 font-medium">Código de Barras Alternativo</label>
                        <input
                            type="text"
                            name="codigo_barras_alternativo"
                            value={produto.codigo_barras_alternativo}
                            onChange={handleChange}
                            autoComplete="off"
                            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-400"
                        />
                    </div>

                    <div>
                        <label className="block text-gray-700 font-medium">Unidade de Medida *</label>
                        <select
                            name="unidade_peso"
                            value={produto.unidade_peso}
                            onChange={handleChange}
                            className="w-full px-4 py-2 border rounded-lg bg-white focus:ring-2 focus:ring-blue-400"
                            required
                        >
                            <option value="kg">Quilograma (kg)</option>
                            <option value="l">Litro (l)</option>
                            <option value="unidade">Unidade</option>
                            <option value="caixa">Caixa</option>
                        </select>
                        <small className="text-gray-500 text-xs block mt-1">
                            💡 O peso/quantidade específica será informado na entrada de estoque
                        </small>
                    </div>

                    <div>
                        <label className="block text-gray-700 font-medium">Estoque Mínimo *</label>
                        <input
                            type="number"
                            name="estoque_minimo"
                            value={produto.estoque_minimo}
                            onChange={handleChange}
                            autoComplete="off"
                            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-400"
                            required
                            min="0"
                        />
                    </div>

                    <div>
                        <label className="block text-gray-700 font-medium">Lead Time (dias)</label>
                        <input
                            type="number"
                            name="lead_time_dias"
                            value={produto.lead_time_dias}
                            onChange={handleChange}
                            autoComplete="off"
                            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-400"
                            min="0"
                        />
                        <small className="text-gray-500 text-xs block mt-1">
                            Tempo estimado para reposição do estoque
                        </small>
                    </div>

                    <div className="flex justify-between">
                        <button 
                            type="submit"
                            className="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 transition"
                        >
                            {produtoEditado ? 'Salvar Alterações' : 'Cadastrar Produto'}
                        </button>

                        <button 
                            type="button"
                            className="bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition"
                            onClick={fecharModal}
                        >
                            Cancelar
                        </button>
                    </div>
                </form>

                {mostrarModalImportacao && (
                    <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50" style={{ zIndex: 10000 }}>
                        <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md relative">
                            <button
                                className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
                                onClick={() => setMostrarModalImportacao(false)}
                            >
                                <FaTimes size={20} />
                            </button>
                            <h2 className="text-lg font-semibold text-center text-gray-700 mb-4">
                                Importar Produtos
                            </h2>
                            <ProductImport fecharModal={() => setMostrarModalImportacao(false)} />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProductForm;